// extracted by mini-css-extract-plugin
module.exports = {"doubleclick":"styles_doubleclick__3J_1P","loading":"styles_loading__35G1C"};